export default __webpack_public_path__ + "logo172eca91.png";